import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import { type NavItemVariant } from './navRowClass';

/** The badge rides the top-right corner while the row is an icon square, and
 *  sits inline at the end of the row once there is a label beside it — so it
 *  follows the same breakpoints the label does. */
const BADGE_CLASS: Record<NavItemVariant, string> = {
  panel:
    'absolute right-1 top-1 h-3.5 min-w-3.5 text-[9px] lg:static lg:ml-auto lg:h-4 lg:min-w-4 lg:text-[10px]',
  'panel-collapsed': 'absolute right-1 top-1 h-3.5 min-w-3.5 text-[9px]',
  'panel-expanded': 'ml-auto h-4 min-w-4 text-[10px]',
  drawer: 'ml-auto h-4 min-w-4 text-[10px]',
};

interface NavItemBadgeProps {
  count: number;
  variant: NavItemVariant;
}

/** Numeric count on a nav item (e.g. open review flags). */
export default function NavItemBadge({ count, variant }: NavItemBadgeProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <span
      className={`flex items-center justify-center rounded-full px-[3px] font-bold leading-none text-white ${BADGE_CLASS[variant]}`}
      style={{ background: t.warn }}
    >
      {count}
    </span>
  );
}
